var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-card",
        [
          _c(
            "b-tabs",
            { attrs: { "content-class": "mt-3" } },
            [
              _c(
                "b-tab",
                {
                  attrs: {
                    title: _vm.$t(
                      "reporting_channel.workflow_config.basic_tab"
                    ),
                    active: ""
                  }
                },
                [
                  _c("basic-data-tab", {
                    attrs: { id: _vm.id },
                    on: { saved: _vm.handleSaved }
                  })
                ],
                1
              ),
              _c(
                "b-tab",
                {
                  attrs: {
                    title: _vm.$t(
                      "reporting_channel.workflow_config.deadlines_tab"
                    ),
                    disabled: !_vm.id
                  }
                },
                [
                  _c("deadline-config-tab", {
                    attrs: { id: _vm.id, "workflow-config-id": _vm.id }
                  })
                ],
                1
              ),
              _c(
                "b-tab",
                {
                  attrs: {
                    title: _vm.$t(
                      "reporting_channel.workflow_config.destinations_tab"
                    ),
                    disabled: !_vm.id
                  }
                },
                [_c("destinatarios-tab", { attrs: { id: _vm.id } })],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }